// extracted by mini-css-extract-plugin
export default {"containerLanding":"components_containerLanding__1-xo2"};